import { api } from './base';

import { MutationArg, Pageable } from 'v2/types';
import {
  BroadcastNotification,
  BroadcastNotificationRequest,
  BroadcastNotificationResponse,
} from 'v2/types/BroadcastNotificationModel';
import { SWRKeyPagination, SWRKeyValue } from 'v2/types/swr';

const BASE = 'v1/admin/broadcast-notification';

interface ListResponse {
  result: BroadcastNotification[];
  total: number;
}

export const broadcastNotificationService = {
  broadcast(_key: string, { arg }: MutationArg<BroadcastNotificationRequest>): Promise<BroadcastNotificationResponse> {
    return api.post(`${BASE}`, { json: arg, timeout: 20_000 }).json();
  },

  unpinNotification(_key: string): Promise<void> {
    return api.delete(`${BASE}/pin`).json();
  },

  async getList([_key, page, limit]: SWRKeyPagination): Promise<Pageable<BroadcastNotification>> {
    const res = await api
      .get(`${BASE}`, { searchParams: { page, limit, sortFields: JSON.stringify({ createdAt: 'desc' }) } })
      .json<ListResponse>();

    return { result: res.result, total: res.total };
  },

  update([_key, id]: SWRKeyValue, { arg }: MutationArg<BroadcastNotificationRequest>): Promise<BroadcastNotification> {
    return api.put(`${BASE}/${id}`, { json: arg }).json();
  },
};
